export type CastMember = {
  name: string;
  role: string;
  avatar: string;
  bio: string;
};

export type Movie = {
  id: string;
  title: string;
  subtitle: string;
  year: number;
  type: string;
  genres: string[];
  region: string;
  duration: string;
  director: string;
  cast: CastMember[];
  rating: number;
  cover: string;
  hero?: string;
  summary: string;
  synopsis: string;
  tags: string[];
  featured?: boolean;
};

const ACTOR_AVATARS = [
  "https://readdy.ai/api/search-image?query=soft%20studio%20portrait%20of%20an%20elegant%20asian%20woman%20with%20short%20dark%20hair%2C%20neutral%20warm%20beige%20background%2C%20soft%20directional%20light%2C%20editorial%20photography%2C%20calm%20expression&width=320&height=320&seq=actor-face-01&orientation=squarish",
  "https://readdy.ai/api/search-image?query=soft%20studio%20portrait%20of%20a%20mature%20asian%20man%20in%20a%20dark%20shirt%2C%20muted%20grey%20background%2C%20soft%20side%20light%2C%20editorial%20photography%2C%20serious%20expression&width=320&height=320&seq=actor-face-02&orientation=squarish",
  "https://readdy.ai/api/search-image?query=soft%20studio%20portrait%20of%20a%20young%20asian%20man%20with%20neat%20hair%2C%20warm%20sand%20colored%20background%2C%20gentle%20lighting%2C%20editorial%20photography&width=320&height=320&seq=actor-face-03&orientation=squarish",
  "https://readdy.ai/api/search-image?query=soft%20studio%20portrait%20of%20a%20refined%20older%20asian%20woman%20with%20grey%20hair%2C%20pale%20neutral%20background%2C%20soft%20window%20light%2C%20editorial%20photography&width=320&height=320&seq=actor-face-04&orientation=squarish",
  "https://readdy.ai/api/search-image?query=soft%20studio%20portrait%20of%20an%20asian%20woman%20with%20long%20straight%20hair%2C%20muted%20olive%20background%2C%20cinematic%20lighting%2C%20editorial%20photography&width=320&height=320&seq=actor-face-05&orientation=squarish",
  "https://readdy.ai/api/search-image?query=soft%20studio%20portrait%20of%20an%20asian%20man%20with%20glasses%20and%20short%20beard%2C%20warm%20neutral%20background%2C%20soft%20light%2C%20editorial%20photography&width=320&height=320&seq=actor-face-06&orientation=squarish",
];

export const movieTypeOptions = ["全部", "电影", "纪录片", "剧集", "短片"];

export const movieDecadeOptions = ["全部", "2020年代", "2010年代", "2000年代"];

export const movieGenreOptions = [
  "全部",
  "剧情",
  "爱情",
  "悬疑",
  "犯罪",
  "动作",
  "武侠",
  "科幻",
  "历史",
  "喜剧",
  "家庭",
  "文艺",
  "谍战",
  "惊悚",
];

export const movies: Movie[] = [
  {
    id: "se-jie",
    title: "色戒",
    subtitle: "Lust, Caution",
    year: 2007,
    type: "电影",
    genres: ["剧情", "爱情", "悬疑"],
    region: "中国香港 / 中国大陆",
    duration: "158分钟",
    director: "李安",
    rating: 8.7,
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20cinematic%20movie%20poster%20art%2C%20silhouette%20of%20a%20woman%20wearing%201940s%20qipao%20against%20deep%20navy%20background%2C%20single%20warm%20amber%20light%20from%20the%20side%2C%20moody%20atmospheric%20painterly%20texture%2C%20elegant%20negative%20space%2C%20no%20text&width=600&height=900&seq=sejie-cover-main&orientation=portrait",
    hero:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20dim%201940s%20shanghai%20street%20at%20night%20with%20light%20rain%2C%20wet%20stone%20pavement%20reflecting%20warm%20amber%20lantern%20glow%2C%20deep%20navy%20blue%20shadows%2C%20dramatic%20atmospheric%20film%20still%2C%20painterly%2C%20no%20people%20in%20focus&width=1920&height=1080&seq=sejie-hero-main&orientation=landscape",
    summary:
      "民国乱世里的一场以情感为赌注的谍战，年轻女学生与目标人物之间真假难辨的角力，让所有人都失去了退路。",
    synopsis:
      "故事发生在抗战时期的上海与香港。一名还在读书的年轻女学生，因为一次校园话剧被同学推到了舞台中央，也因此被卷入一场针对敌方要员的秘密行动。她被安排以另一种身份接近对方，用最私人的方式换取最危险的情报。\n\n随着接触越来越深，两人之间的试探逐渐变成了无法命名的依赖。行动的组织者不断催促收网，而她必须在完成任务和保护自己之间做出选择。那些原本清晰的立场，在一枚戒指、一首歌、一场雨里变得模糊。\n\n影片以极为克制的镜头语言呈现了那个时代的压抑与暧昧，大量使用近景与暗调光线，把人物的犹疑藏在眼神和沉默之间。这也是本站在「高清修复」单元中重点推荐的作品。",
    tags: ["谍战", "民国", "经典改编", "高清修复", "文学改编"],
    featured: true,
    cast: [
      {
        name: "汤唯",
        role: "王佳芝",
        avatar: ACTOR_AVATARS[0],
        bio: "以细腻内敛的表演塑造了这位在任务与情感之间摇摆的女学生，眼神层次尤其被观众称道。",
      },
      {
        name: "梁朝伟",
        role: "易先生",
        avatar: ACTOR_AVATARS[1],
        bio: "擅长用极少的外化动作传递人物内心的戒备与疲惫，本片中大量沉默的戏份极具张力。",
      },
      {
        name: "王力宏",
        role: "邝裕民",
        avatar: ACTOR_AVATARS[2],
        bio: "饰演行动小组的发起者之一，把青年的热血与犹疑同时呈现在镜头前。",
      },
      {
        name: "陈冲",
        role: "易太太",
        avatar: ACTOR_AVATARS[3],
        bio: "以从容的台词节奏塑造了公馆里最具分量感的女性角色，几场牌桌戏份耐人寻味。",
      },
    ],
  },
  {
    id: "shen-hai-hui-sheng",
    title: "深海回声",
    subtitle: "Echoes of the Deep",
    year: 2023,
    type: "电影",
    genres: ["剧情", "悬疑"],
    region: "中国大陆",
    duration: "122分钟",
    director: "陈叙",
    rating: 8.4,
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20cinematic%20poster%2C%20abstract%20deep%20ocean%20trench%20with%20a%20single%20thin%20beam%20of%20light%20descending%2C%20navy%20blue%20and%20teal%20palette%2C%20subtle%20grain%2C%20elegant%20negative%20space%2C%20no%20text&width=600&height=900&seq=movie-cover-deepsea&orientation=portrait",
    summary:
      "一支深海科考队在万米海沟里收到来源不明的声呐信号，随着记录被逐帧还原，队员们开始怀疑彼此。",
    synopsis:
      "一支由声学专家、潜航员与随船记者组成的科考队，在西南太平洋执行一次常规的海沟勘测任务。第三天的凌晨，仪器记录到一段重复出现、却不符合任何已知生物特征的声呐信号。\n\n随着逐帧还原，信号中出现了类似人类语言的节奏。队内开始分裂：有人认为这是地质活动的误读，有人坚信海面之下还有别的东西。当潜航器第二次下潜，通讯中断了整整十七分钟。\n\n影片用封闭空间与极简的声音设计制造压迫感，几乎没有使用传统配乐，所有的紧张都来自呼吸声和水流的回响。",
    tags: ["海洋", "封闭空间", "声音设计", "口碑佳作"],
    cast: [
      {
        name: "周砚",
        role: "声学专家 何川",
        avatar: ACTOR_AVATARS[5],
        bio: "以克制的方式演绎了一个被数据说服、又被直觉拖入深渊的科学家。",
      },
      {
        name: "林知夏",
        role: "随船记者",
        avatar: ACTOR_AVATARS[4],
        bio: "片中大量独白由她完成，声音表演被认为是全片最动人的部分。",
      },
      {
        name: "高维",
        role: "潜航员 老麦",
        avatar: ACTOR_AVATARS[1],
        bio: "把老派技术人员的固执和柔软同时演了出来，配角却非常抢眼。",
      },
    ],
  },
  {
    id: "chang-ye-jiang-jin",
    title: "长夜将尽",
    subtitle: "Before the Long Night Ends",
    year: 2024,
    type: "电影",
    genres: ["犯罪", "剧情"],
    region: "中国大陆",
    duration: "134分钟",
    director: "韩牧",
    rating: 8.1,
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20cinematic%20poster%2C%20rain%20soaked%20empty%20city%20street%20at%20night%2C%20lone%20figure%20under%20a%20streetlamp%2C%20deep%20navy%20tones%20with%20one%20amber%20light%2C%20moody%20grain%2C%20no%20text&width=600&height=900&seq=movie-cover-longnight&orientation=portrait",
    summary:
      "一名即将退休的刑警在最后一班岗上接手旧案，卷宗里的证人与他二十年前错过的那个夜晚重新重叠。",
    synopsis:
      "距离退休还有十四天，老刑警接到一宗看似普通的入室案件。现场留下的细节，让他想起二十年前那桩始终没有结案的旧事。\n\n他开始独自沿着当年的线索重新走访，却发现所有证人都已经搬离，档案室里的一部分记录不知去向。唯一还愿意开口的人，是一个在便利店上夜班的中年女人。\n\n影片没有把重点放在侦破过程，而是关于一个人如何在有限的时间里，与自己的遗憾达成和解。",
    tags: ["悬疑犯罪", "老戏骨", "城市夜景", "年度佳作"],
    cast: [
      {
        name: "邵川",
        role: "刑警 老顾",
        avatar: ACTOR_AVATARS[1],
        bio: "全片几乎每一场戏都在走路，用步伐和背影完成了人物的全部历史。",
      },
      {
        name: "陶青",
        role: "便利店店主",
        avatar: ACTOR_AVATARS[3],
        bio: "戏份不多，却以极简的表演撑起了影片后半段的情感重量。",
      },
      {
        name: "李沉",
        role: "年轻搭档",
        avatar: ACTOR_AVATARS[2],
        bio: "代表新一代办案方式，与老刑警形成了极具火花的两代对照。",
      },
    ],
  },
  {
    id: "wu-gang-mi-an",
    title: "雾港疑云",
    subtitle: "Harbor in Fog",
    year: 2022,
    type: "电影",
    genres: ["悬疑", "犯罪"],
    region: "中国香港",
    duration: "118分钟",
    director: "区立行",
    rating: 7.9,
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20cinematic%20poster%2C%20foggy%20container%20harbor%20with%20cargo%20crane%20silhouettes%2C%20muted%20navy%20grey%20palette%2C%20one%20distant%20amber%20light%2C%20heavy%20atmosphere%2C%20no%20text&width=600&height=900&seq=movie-cover-fogharbor&orientation=portrait",
    summary: "浓雾封港的七十二小时里，一起失踪案把码头上的三拨人绑到了同一条船上。",
    synopsis:
      "一场罕见的大雾让港口停摆，所有船只无法进出。就在封港的第一晚，码头调度员失踪了。\n\n警方、船务公司和在码头讨生活的小人物，各自有各自的秘密。七十二小时里，监控、通话记录和一张被撕掉的货运单，把三条互不相干的线索慢慢拧在一起。\n\n影片几乎全部在夜间的港口实景拍摄，雾、集装箱和吊机成为重要的视觉母题。",
    tags: ["港产片", "群像", "迷雾", "反转"],
    cast: [
      {
        name: "张鹤鸣",
        role: "督察 陈朗",
        avatar: ACTOR_AVATARS[1],
        bio: "在类型片里总能给出意外细节的演员，本片中的疲惫感非常真实。",
      },
      {
        name: "何蔚",
        role: "船务主管",
        avatar: ACTOR_AVATARS[4],
        bio: "冷静语速下藏着锋利的算计，是全片最难判断立场的人物。",
      },
      {
        name: "吴岸",
        role: "码头工人",
        avatar: ACTOR_AVATARS[5],
        bio: "港片里熟悉的面孔，这一次承担了影片最柔软的一段戏。",
      },
    ],
  },
  {
    id: "gui-tu-lie-che",
    title: "归途列车",
    subtitle: "The Way Home",
    year: 2021,
    type: "电影",
    genres: ["剧情", "家庭"],
    region: "中国大陆",
    duration: "112分钟",
    director: "苏迟",
    rating: 8.3,
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20cinematic%20poster%2C%20long%20railway%20track%20curving%20through%20misty%20mountains%20at%20dawn%2C%20warm%20amber%20sunrise%20breaking%20through%20navy%20blue%20mist%2C%20quiet%20melancholic%20mood%2C%20no%20text&width=600&height=900&seq=movie-cover-hometrain&orientation=portrait",
    summary: "父亲去世后，兄妹三人挤上一趟慢车回乡，十二小时的车程里把二十年的旧账翻了一遍。",
    synopsis:
      "父亲在老家去世的消息传来时，三个已经多年不往来的兄妹分别从三座城市出发，坐上同一趟绿皮火车。\n\n车厢里坐着返乡的工人、放假的学生、挑着担子的老人。十二个小时里，他们从沉默到争执，从争执到回忆，慢慢拼出一个他们从未真正了解过的父亲。\n\n影片大量使用自然光和真实车厢环境，几乎所有的情绪都发生在过道、餐车和卧铺之间的缝隙里。",
    tags: ["家庭", "公路电影", "现实主义", "催泪"],
    cast: [
      {
        name: "罗启",
        role: "长子",
        avatar: ACTOR_AVATARS[1],
        bio: "把一个沉默寡言的中年男人的愧疚演得极有分寸。",
      },
      {
        name: "沈听",
        role: "次女",
        avatar: ACTOR_AVATARS[0],
        bio: "全片的情绪出口，几场哭戏克制而有力量。",
      },
      {
        name: "罗一舟",
        role: "幼子",
        avatar: ACTOR_AVATARS[2],
        bio: "年轻演员，用松弛的状态带出了家庭里最轻松的一面。",
      },
    ],
  },
  {
    id: "shan-hai-zhi-jian",
    title: "山海之间",
    subtitle: "Between Mountains and Sea",
    year: 2023,
    type: "纪录片",
    genres: ["剧情", "文艺"],
    region: "中国大陆",
    duration: "96分钟",
    director: "程野",
    rating: 9.1,
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20documentary%20poster%2C%20layered%20mountain%20ridges%20rising%20above%20a%20sea%20of%20clouds%2C%20ink%20wash%20painting%20style%2C%20warm%20sand%20and%20deep%20navy%20tones%2C%20serene%20and%20vast%2C%20no%20text&width=600&height=900&seq=movie-cover-mountainsea&orientation=portrait",
    summary: "四季跟拍三条山谷里的普通人，记录他们如何在自然的节奏里安排自己的生活。",
    synopsis:
      "摄制组用了两年时间，在同一片山区完成四季拍摄。镜头跟着采药人上山，跟着守林人巡夜，也跟着一个刚回乡的年轻人学着重修老屋。\n\n片中没有旁白，也不刻意解释。观众看到的是雨落在瓦上的声音、柴火燃烧的爆裂声，以及人们在清晨出门时踩过碎石路的脚步。\n\n这是一部关于时间的纪录片：不急着告诉你结论，只让你在里面待一会儿。",
    tags: ["自然", "人文", "四季", "高口碑纪录片"],
    cast: [
      {
        name: "程野",
        role: "导演 / 摄影",
        avatar: ACTOR_AVATARS[5],
        bio: "长期拍摄人文纪录片的导演，擅长用极少的干预保留真实的生活质感。",
      },
      {
        name: "老周",
        role: "采药人",
        avatar: ACTOR_AVATARS[1],
        bio: "在山里生活了六十余年，片中关于节气的讲述成为观众印象最深的段落。",
      },
      {
        name: "阿岚",
        role: "回乡青年",
        avatar: ACTOR_AVATARS[4],
        bio: "代表新一代的选择，为影片提供了与土地重新连接的视角。",
      },
    ],
  },
  {
    id: "bai-lu-yuan-shang",
    title: "白鹿原上",
    subtitle: "On the White Deer Plain",
    year: 2020,
    type: "电影",
    genres: ["剧情", "历史"],
    region: "中国大陆",
    duration: "145分钟",
    director: "田川",
    rating: 8.0,
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20cinematic%20poster%2C%20golden%20wheat%20field%20under%20a%20vast%20sky%20with%20a%20distant%20village%20silhouette%2C%20warm%20ochre%20and%20deep%20navy%20tones%2C%20epic%20historical%20drama%20mood%2C%20no%20text&width=600&height=900&seq=movie-cover-whitedeer&orientation=portrait",
    summary: "两代人在同一片土地上耕作、争执与和解，一个村庄的变迁折射出几十年的时代更替。",
    synopsis:
      "故事围绕一个北方村庄里的两个家族展开。土地、水渠和一场没有结果的婚约，把两家人的命运紧紧绑在一起。\n\n从春耕到秋收，从集体劳动到年轻人外出打工，影片用极其扎实的生活细节，呈现了乡村社会如何在变化中维持自己的秩序。\n\n导演选择了大量的长镜头与固定机位，让观众像站在田埂上一样，安静地看着时间流过。",
    tags: ["乡土", "年代", "长镜头", "文学改编"],
    cast: [
      {
        name: "白守义",
        role: "老族长",
        avatar: ACTOR_AVATARS[1],
        bio: "舞台出身的老演员，台词功底让整部影片的分量稳了下来。",
      },
      {
        name: "田小满",
        role: "长女",
        avatar: ACTOR_AVATARS[0],
        bio: "把一代农村女性的隐忍与倔强演得层次分明。",
      },
      {
        name: "赵沉舟",
        role: "返乡青年",
        avatar: ACTOR_AVATARS[2],
        bio: "影片中唯一带出外部世界气息的角色。",
      },
    ],
  },
  {
    id: "chun-fen-na-ye",
    title: "春分那夜",
    subtitle: "The Night of Spring Equinox",
    year: 2024,
    type: "电影",
    genres: ["爱情", "剧情"],
    region: "中国大陆",
    duration: "104分钟",
    director: "许南",
    rating: 7.7,
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20romantic%20cinematic%20poster%2C%20two%20small%20silhouettes%20standing%20on%20a%20rooftop%20at%20dusk%20above%20city%20lights%20bokeh%2C%20warm%20orange%20and%20deep%20navy%20gradient%2C%20tender%20quiet%20mood%2C%20no%20text&width=600&height=900&seq=movie-cover-springnight&orientation=portrait",
    summary: "两个在城市里错过很多次的人，终于在春分这天夜里坐上同一班末班车。",
    synopsis:
      "她做着一份需要在深夜收工的工作，他习惯在末班车上把当天的事写进本子。两个人在同一座城市里生活了很多年，却直到春分那夜才第一次说上话。\n\n影片几乎全部发生在夜里：便利店、天桥、24小时洗衣店和空荡的地铁站。对白不多，更多时候是并肩走路。\n\n这是一部很轻的电影，讲的是两个普通人怎样在一段很短的时间里，被另一个人认真看见。",
    tags: ["都市爱情", "夜戏", "治愈", "新导演"],
    cast: [
      {
        name: "宋遥",
        role: "宋一",
        avatar: ACTOR_AVATARS[4],
        bio: "气质干净的新生代女演员，本片中的沉默戏份非常耐看。",
      },
      {
        name: "顾南声",
        role: "陈默",
        avatar: ACTOR_AVATARS[2],
        bio: "用很小的表演幅度完成了人物的转变，被评价为「不抢戏但抓人」。",
      },
      {
        name: "许南",
        role: "导演",
        avatar: ACTOR_AVATARS[5],
        bio: "以拍摄城市夜景见长，善于把日常空间拍出温柔的层次。",
      },
    ],
  },
  {
    id: "huo-che-zhan",
    title: "火车站",
    subtitle: "The Station",
    year: 2019,
    type: "电影",
    genres: ["剧情", "文艺"],
    region: "中国大陆",
    duration: "98分钟",
    director: "孟町",
    rating: 7.8,
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20cinematic%20poster%2C%20lone%20traveler%20with%20a%20suitcase%20standing%20on%20an%20empty%20platform%2C%20cold%20navy%20tones%20with%20a%20single%20warm%20lamp%2C%20long%20shadows%2C%20quiet%20melancholy%2C%20no%20text&width=600&height=900&seq=movie-cover-station&orientation=portrait",
    summary: "一个在火车站过夜的中年人，用一整晚时间决定要不要回到那个他已经离开的家。",
    synopsis:
      "深夜十一点，最后一班车开走之后，候车厅里只剩几个人。一个提着旧行李箱的中年男人坐在角落里，反复看一张已经过期的车票。\n\n他和值夜班的站务员、卖夜宵的夫妻、一个离家出走的少年聊了整晚。每一次谈话都让他离那个决定更近一点，也更远一点。\n\n全片九十八分钟几乎只有一个场景，但依靠细腻的对白和光线变化，一点也不闷。",
    tags: ["单场景", "对白驱动", "小成本", "影展入围"],
    cast: [
      {
        name: "孟町",
        role: "导演 / 编剧",
        avatar: ACTOR_AVATARS[5],
        bio: "擅长在极小空间里调度人物关系，本片是他的第二部长片。",
      },
      {
        name: "唐守",
        role: "中年旅客",
        avatar: ACTOR_AVATARS[1],
        bio: "凭借这个角色获得多个影展的最佳男主角提名。",
      },
      {
        name: "赵一诺",
        role: "站务员",
        avatar: ACTOR_AVATARS[0],
        bio: "把一个话不多但很会听的角色演得格外温暖。",
      },
    ],
  },
  {
    id: "yin-yi-zhi-cheng",
    title: "隐匿之城",
    subtitle: "The Hidden City",
    year: 2023,
    type: "剧集",
    genres: ["科幻", "悬疑"],
    region: "中国大陆",
    duration: "全12集 / 单集45分钟",
    director: "路原",
    rating: 8.6,
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20sci%20fi%20poster%2C%20futuristic%20city%20towers%20emerging%20from%20dense%20fog%20with%20geometric%20light%20beams%2C%20deep%20navy%20and%20amber%20accent%20tones%2C%20clean%20architectural%20composition%2C%20no%20text&width=600&height=900&seq=movie-cover-hiddencity&orientation=portrait",
    summary: "一座地图上不存在的城市，住着所有被世界遗忘的人，而新来的调查员发现自己的档案也在其中。",
    synopsis:
      "一名城市档案调查员被派往一处地图上找不到的地点，任务是核对一批身份信息。抵达之后他发现，这里所有人都记得自己是怎么来的，却没有人说得清这里究竟在哪。\n\n随着调查深入，他找到了自己的档案。档案上的照片比他现在的样子年轻了整整十年。\n\n剧集用十二集的篇幅搭建了一个完整的规则体系，每一集都会解开一个疑问，同时抛出一个更深的疑问。",
    tags: ["国产剧集", "世界观", "身份谜题", "高完成度"],
    cast: [
      {
        name: "路原",
        role: "导演",
        avatar: ACTOR_AVATARS[5],
        bio: "以严谨的世界观搭建著称，本剧的视觉设定集也被大量讨论。",
      },
      {
        name: "程亦",
        role: "调查员",
        avatar: ACTOR_AVATARS[2],
        bio: "撑起了大量独角戏，把人物的怀疑演得层层递进。",
      },
      {
        name: "苏黎",
        role: "档案管理员",
        avatar: ACTOR_AVATARS[4],
        bio: "是全剧最神秘的角色，直到最后一集才交出真正的答案。",
      },
    ],
  },
  {
    id: "feng-sheng",
    title: "风声再起",
    subtitle: "Whispers Again",
    year: 2022,
    type: "剧集",
    genres: ["谍战", "剧情", "悬疑"],
    region: "中国大陆",
    duration: "全24集 / 单集42分钟",
    director: "钟时",
    rating: 8.2,
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20spy%20thriller%20poster%2C%20vintage%20microphone%20and%20scattered%20documents%20on%20a%20dark%20wooden%20desk%2C%20tungsten%20warm%20light%20beam%2C%20deep%20navy%20shadows%2C%20grainy%20texture%2C%20no%20text&width=600&height=900&seq=movie-cover-whisper&orientation=portrait",
    summary: "一份被截获的密电，让情报站里的每一个人都有了两个名字。",
    synopsis:
      "故事从一封被截获的密电开始。电文只有短短三行，却足以让整个情报站陷入互相怀疑。\n\n二十四集的篇幅里，几乎每个人都在向不同的人汇报，每一句台词都可能是暗号。观众跟随年轻译电员的视角，一点点分辨谁在说谎。\n\n剧集在美术和道具上非常考究，大量的打字机音效和电报声构成了独特的听觉标识。",
    tags: ["谍战剧", "群像", "案中案", "高智商"],
    cast: [
      {
        name: "钟时",
        role: "导演",
        avatar: ACTOR_AVATARS[1],
        bio: "擅长处理多线叙事，本剧的时间线交错被观众反复拆解。",
      },
      {
        name: "林砚秋",
        role: "译电员",
        avatar: ACTOR_AVATARS[0],
        bio: "从怯生生到沉稳的成长线，是全剧最完整的人物弧光。",
      },
      {
        name: "陆行",
        role: "站长",
        avatar: ACTOR_AVATARS[1],
        bio: "把一个永远在权衡的角色演得让人又恨又同情。",
      },
    ],
  },
  {
    id: "hai-an-xian",
    title: "海岸线",
    subtitle: "Coastline",
    year: 2021,
    type: "电影",
    genres: ["剧情", "文艺"],
    region: "中国台湾",
    duration: "108分钟",
    director: "侯邑",
    rating: 8.0,
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20arthouse%20poster%2C%20quiet%20coastline%20with%20a%20single%20tiny%20figure%20walking%20on%20wet%20sand%2C%20muted%20blue%20grey%20and%20warm%20sunset%20edge%2C%20vast%20sky%2C%20serene%20loneliness%2C%20no%20text&width=600&height=900&seq=movie-cover-coastline&orientation=portrait",
    summary: "一个渔村女孩在夏天结束时去了城市，十年后带着女儿回到那条已经变样的海岸线。",
    synopsis:
      "影片从一次回乡开始。女主人公带着年幼的女儿回到海边老家，处理母亲留下的旧屋。\n\n海还在，但渔船少了，堤防加高了，小时候走过的那条路被一条公路截断。她在整理旧物的时候，逐渐想起那个决定离开的夏天。\n\n导演用大量固定长镜头拍摄海面，让潮水的声音填满整个影院。这是一部关于离开与回来的电影。",
    tags: ["文艺片", "海边", "女性视角", "长镜头"],
    cast: [
      {
        name: "侯邑",
        role: "导演",
        avatar: ACTOR_AVATARS[5],
        bio: "以缓慢的节奏和自然光著称，作品多次入围国际影展。",
      },
      {
        name: "江月",
        role: "女主人公",
        avatar: ACTOR_AVATARS[0],
        bio: "用非常内敛的方式演出了十年时间在一个人身上留下的痕迹。",
      },
      {
        name: "陈屿",
        role: "旧友",
        avatar: ACTOR_AVATARS[2],
        bio: "代表那个没有被选择的可能，戏份不多但令人难忘。",
      },
    ],
  },
  {
    id: "di-yi-jian",
    title: "第一剑",
    subtitle: "The First Blade",
    year: 2024,
    type: "电影",
    genres: ["动作", "武侠"],
    region: "中国大陆",
    duration: "128分钟",
    director: "雷敬",
    rating: 7.6,
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20wuxia%20poster%2C%20single%20bold%20calligraphy%20brush%20stroke%20forming%20a%20sword%20shape%2C%20ink%20black%20deep%20navy%20background%2C%20amber%20gold%20accent%20glow%2C%20elegant%20negative%20space%2C%20no%20text&width=600&height=900&seq=movie-cover-firstblade&orientation=portrait",
    summary: "铸剑师的关门弟子带着一把从未开刃的剑下山，只为问一个问题：谁有资格出剑。",
    synopsis:
      "山中铸剑四十年，老师父临终前把最后一把没有开刃的剑交给最小的徒弟，让他下山去找一个答案。\n\n江湖上没有人见过不杀人的剑。少年一路被人嘲笑、被人追杀，也被人利用。他逐渐明白，师父要他找的不是对手，而是自己出剑的理由。\n\n影片的动作设计强调重量与呼吸，几乎每一场打斗都伴随漫长的静默。",
    tags: ["武侠", "动作设计", "新人演员", "江湖"],
    cast: [
      {
        name: "雷敬",
        role: "导演",
        avatar: ACTOR_AVATARS[1],
        bio: "武行出身，强调实拍与长镜头动作场面，本片几乎不用威亚。",
      },
      {
        name: "顾青崖",
        role: "铸剑徒弟",
        avatar: ACTOR_AVATARS[2],
        bio: "为角色练了八个月剑，动作场面全部亲自完成。",
      },
      {
        name: "白霜",
        role: "女刺客",
        avatar: ACTOR_AVATARS[4],
        bio: "出场不到二十分钟，却成为影片讨论度最高的角色。",
      },
    ],
  },
  {
    id: "xing-chen",
    title: "星辰之下",
    subtitle: "Under the Stars",
    year: 2020,
    type: "纪录片",
    genres: ["文艺", "历史"],
    region: "中国大陆",
    duration: "88分钟",
    director: "云舟",
    rating: 8.9,
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20documentary%20poster%2C%20night%20sky%20milky%20way%20arching%20over%20a%20desert%20observatory%2C%20deep%20navy%20tones%20with%20warm%20starlight%2C%20vast%20still%20composition%2C%20no%20text&width=600&height=900&seq=movie-cover-understars&orientation=portrait",
    summary: "在戈壁深处守着一台老旧望远镜的三代人，和他们头顶那片越来越亮也越来越远的星空。",
    synopsis:
      "摄制组在西北戈壁的一座观测站驻扎了整个冬天。这里常年只有三个人值班，负责维护一台服役超过三十年的望远镜。\n\n影片记录了他们的日常：扫雪、检修、记录数据、在深夜轮流盯着屏幕。也记录了他们谈论星空时的样子——那是一种外人很难介入的亲密。\n\n当新一代自动化设备进场，老观测站即将关闭。最后一场戏是他们一起把望远镜对准了同一片星云。",
    tags: ["星空", "科技", "人文", "治愈"],
    cast: [
      {
        name: "云舟",
        role: "导演",
        avatar: ACTOR_AVATARS[5],
        bio: "擅长以长时间驻点拍摄换取真实感，本片拍摄周期长达两年。",
      },
      {
        name: "陈守拙",
        role: "观测员",
        avatar: ACTOR_AVATARS[1],
        bio: "在这里工作了二十七年，片中关于「习惯」的那段自述被大量引用。",
      },
      {
        name: "小谢",
        role: "新一代工程师",
        avatar: ACTOR_AVATARS[2],
        bio: "负责自动化改造，也是影片里最有冲突感的视角。",
      },
    ],
  },
  {
    id: "kong-fang-jian",
    title: "空房间",
    subtitle: "The Empty Room",
    year: 2023,
    type: "电影",
    genres: ["惊悚", "悬疑"],
    region: "韩国",
    duration: "106分钟",
    director: "朴度贤",
    rating: 7.5,
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20thriller%20poster%2C%20empty%20hotel%20corridor%20with%20a%20single%20open%20door%20and%20warm%20light%20spilling%20out%2C%20moody%20navy%20shadows%2C%20long%20perspective%2C%20unsettling%20calm%2C%20no%20text&width=600&height=900&seq=movie-cover-emptyroom&orientation=portrait",
    summary: "一间每天都会被重新打扫的客房，住客却坚持说，房间里的东西每天都会自己回来。",
    synopsis:
      "一家老式旅馆的三楼尽头，有一间长期无人入住的客房。新来的夜班前台注意到，这间房每天都会被打扫，但登记表上没有任何记录。\n\n她开始自己记录房间里的变化：水杯的位置、窗帘的角度、床头柜上那本翻开的书。第三天，她发现书页停在了不同的地方。\n\n影片大部分时间只有一个人和一个空间，依靠声音和构图制造持续的紧张感。",
    tags: ["惊悚", "单场景", "心理悬疑", "亚洲类型片"],
    cast: [
      {
        name: "朴度贤",
        role: "导演",
        avatar: ACTOR_AVATARS[5],
        bio: "以低成本高完成度的类型片著称，本片在多个奇幻影展获得好评。",
      },
      {
        name: "金序",
        role: "夜班前台",
        avatar: ACTOR_AVATARS[0],
        bio: "几乎一个人撑起全片，情绪推进极其精准。",
      },
      {
        name: "李道贤",
        role: "旅馆经理",
        avatar: ACTOR_AVATARS[1],
        bio: "他的每一次出现都让观众更加不安。",
      },
    ],
  },
  {
    id: "jie-ri",
    title: "节日",
    subtitle: "The Feast",
    year: 2022,
    type: "电影",
    genres: ["喜剧", "家庭"],
    region: "中国大陆",
    duration: "115分钟",
    director: "毛晓",
    rating: 7.4,
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20warm%20family%20comedy%20poster%2C%20overhead%20view%20of%20a%20festive%20dinner%20table%20with%20lanterns%20and%20steaming%20dishes%2C%20warm%20amber%20and%20deep%20red%20palette%2C%20cozy%20celebratory%20mood%2C%20no%20text&width=600&height=900&seq=movie-cover-feast&orientation=portrait",
    summary: "一大家子人为了过年凑在一起，三天里发生了七场争吵、两次和好和一桌永远热不完的菜。",
    synopsis:
      "除夕前三天，分散在各地的家人陆续回到老房子。有人带着新车，有人带着新对象，也有人什么都没带，只带了一身麻烦。\n\n影片用极其生活化的对白呈现了中国式家庭的相处方式：嘴上不饶人，行动上却都留着位置。年夜饭那场戏拍了整整十七分钟，一镜到底。\n\n这是那种适合和家里人一起看的电影，笑完之后会想给谁打个电话。",
    tags: ["贺岁", "家庭喜剧", "年夜饭", "轻松"],
    cast: [
      {
        name: "毛晓",
        role: "导演",
        avatar: ACTOR_AVATARS[4],
        bio: "擅长拍群戏，本片中的长镜头调度被业内广泛讨论。",
      },
      {
        name: "周桂芬",
        role: "母亲",
        avatar: ACTOR_AVATARS[3],
        bio: "把一个操心了一辈子的母亲演得真实到让人心酸。",
      },
      {
        name: "马小林",
        role: "小儿子",
        avatar: ACTOR_AVATARS[2],
        bio: "全片的笑点担当，也是情绪转折的关键。",
      },
    ],
  },
  {
    id: "qing-shan-lao",
    title: "青山老",
    subtitle: "Old Green Hills",
    year: 2019,
    type: "短片",
    genres: ["剧情", "文艺"],
    region: "中国大陆",
    duration: "42分钟",
    director: "郑野",
    rating: 8.5,
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20short%20film%20poster%2C%20elderly%20hands%20holding%20a%20porcelain%20tea%20cup%20near%20a%20window%2C%20soft%20morning%20light%2C%20warm%20neutral%20beige%20and%20navy%20tones%2C%20quiet%20intimate%20mood%2C%20no%20text&width=600&height=900&seq=movie-cover-greenhills&orientation=portrait",
    summary: "一位独居老人每天给已经停机的号码打电话，直到某天电话那头真的有人接了。",
    synopsis:
      "老人每天下午三点都会拨同一个号码，响到自动挂断为止。邻居知道那个号码已经停机很多年了，从来没人劝得住他。\n\n某一天，电话被接起了。对面是一个刚搬来这座城市的年轻人，用的是回收后的号码。两个陌生人从此开始了一段固定的通话。\n\n四十二分钟的短片，几乎全部由两个人的电话对白构成，结尾克制而温柔。",
    tags: ["短片", "孤独", "电话", "影展获奖"],
    cast: [
      {
        name: "郑野",
        role: "导演",
        avatar: ACTOR_AVATARS[5],
        bio: "短片作品多次入围国内外影展，本片为他获得最佳短片的作品。",
      },
      {
        name: "徐茂",
        role: "老人",
        avatar: ACTOR_AVATARS[1],
        bio: "仅凭声音和手部动作就完成了人物塑造。",
      },
      {
        name: "阿朵",
        role: "接电话的年轻人",
        avatar: ACTOR_AVATARS[0],
        bio: "声音表演自然，是全片的情绪对手。",
      },
    ],
  },
  {
    id: "yong-heng-de-yi-tian",
    title: "永恒的一天",
    subtitle: "An Eternal Day",
    year: 2024,
    type: "电影",
    genres: ["科幻", "剧情"],
    region: "中国大陆",
    duration: "126分钟",
    director: "林潮",
    rating: 8.2,
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20surreal%20sci%20fi%20poster%2C%20clock%20face%20merging%20with%20an%20ocean%20horizon%2C%20deep%20navy%20and%20warm%20orange%20gradient%2C%20clean%20geometric%20composition%2C%20contemplative%20mood%2C%20no%20text&width=600&height=900&seq=movie-cover-eternalday&orientation=portrait",
    summary: "一场实验让同一小时不断重复，而唯一记得所有循环的人，决定用这一天去挽回一件事。",
    synopsis:
      "城市在一次能量实验之后，被困在了同一个小时里。大多数人毫无察觉，只有少数人对重复感到不适。\n\n男主角是实验的参与者之一。他发现自己可以在每次循环中保留记忆，也知道一小时后会发生什么。于是他开始反复尝试同一件事：阻止那场事故。\n\n影片没有把重点放在科幻设定上，而是关于一个人愿意为弥补一个遗憾，重复多少次同一天。",
    tags: ["时间循环", "软科幻", "情感", "原创剧本"],
    cast: [
      {
        name: "林潮",
        role: "导演 / 编剧",
        avatar: ACTOR_AVATARS[5],
        bio: "以原创科幻剧本见长，本片的设定被评价为「小而完整」。",
      },
      {
        name: "程一鸣",
        role: "实验员",
        avatar: ACTOR_AVATARS[2],
        bio: "在大量重复场景中演出了微妙的差别，表演难度极高。",
      },
      {
        name: "苏漫",
        role: "关键人物",
        avatar: ACTOR_AVATARS[4],
        bio: "她的每一次选择都决定了循环的走向。",
      },
    ],
  },
];